// MetabaseModal Component - Credentials modal for Metabase access

import { Button, Modal } from '../common';
import styles from './MetabaseModal.module.css';

const METABASE_CREDENTIALS = {
  email: 'admin@chemmasters.net',
  password: 'ChemMasters2024!',
};

interface MetabaseModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export function MetabaseModal({ isOpen, onClose }: MetabaseModalProps) {
  const handleCopyCredential = (text: string) => {
    navigator.clipboard.writeText(text);
  };

  const handleOpenMetabase = () => {
    window.open('/metabase/', '_blank');
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Metabase Access">
      <div className={styles.modal}>
        <p className={styles.info}>
          Use the following credentials to log in to Metabase:
        </p>

        <div className={styles.credentialRow}>
          <label>Email:</label>
          <div className={styles.credentialValue}>
            <code>{METABASE_CREDENTIALS.email}</code>
            <button
              className={styles.copyButton}
              onClick={() => handleCopyCredential(METABASE_CREDENTIALS.email)}
              title="Copy email"
            >
              Copy
            </button>
          </div>
        </div>

        <div className={styles.credentialRow}>
          <label>Password:</label>
          <div className={styles.credentialValue}>
            <code>{METABASE_CREDENTIALS.password}</code>
            <button
              className={styles.copyButton}
              onClick={() => handleCopyCredential(METABASE_CREDENTIALS.password)}
              title="Copy password"
            >
              Copy
            </button>
          </div>
        </div>

        <div className={styles.actions}>
          <Button variant="secondary" onClick={onClose}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleOpenMetabase}>
            Open Metabase
          </Button>
        </div>
      </div>
    </Modal>
  );
}
